export const CREATE_DELIVERYS_SUCCEEDED = 'CREATE_DELIVERYS_SUCCEEDED';
export const CREATE_DELIVERYS_REQUESTED = 'CREATE_DELIVERYS_REQUESTED';

export const REMOVE_PRODUCT_DELIVERY = 'REMOVE_PRODUCT_DELIVERY';
export const CLEAR_PRODUCT_DELIVERY = 'CLEAR_PRODUCT_DELIVERY';

export const TOGGLE_COLLAPSE_DATA_DELIVERY = 'TOGGLE_COLLAPSE_DATA_DELIVERY';
export const ADD_DATA_DELIVERY = 'ADD_DATA_DELIVERY';
export const REMOVE_DATA_DELIVERY = 'REMOVE_DATA_DELIVERY';

export const SEARCH_AND_ADD_DATA_DELIVERY = 'SEARCH_AND_ADD_DATA_DELIVERY';
